import createProps from '@kissui/helpers/src/props.helpers'

class EnergyLabel extends HTMLElement {
    constructor() {
        super()
        this.props = {}
        this.level = ''
        this.levelPlus = ''
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
    }

    render() {
        const { a11y_label, level } = this.props

        if (a11y_label === '' || level === '') {
            return ''
        }

        this.classList.add(`level_${level}`)

        switch (level) {
            case 'g':
                this.level = 'G'
                break
            case 'f':
                this.level = 'F'
                break
            case 'e':
                this.level = 'E'
                break
            case 'd':
                this.level = 'D'
                break
            case 'c':
                this.level = 'C'
                break
            case 'b':
                this.level = 'B'
                break
            case 'a4':
                this.level = 'A'
                break
            case 'a3':
                this.level = 'A'
                this.levelPlus = '+'
                break
            case 'a2':
                this.level = 'A'
                this.levelPlus = '++'
                break
            default:
                this.level = 'A'
                this.levelPlus = '+++'
                break
        }

        this.innerHTML = `
            <mark>
                ${this.level}
                ${this.levelPlus !== '' ? `<sup>${this.levelPlus}</sup>` : ''}
                <span class="sr-only">${a11y_label} ${this.level}${this.levelPlus}</span>
            </mark>
        `
    }
}

customElements.get('nb-energy-label') || customElements.define('nb-energy-label', EnergyLabel)

export default EnergyLabel
